module.exports = __webpack_public_path__ + "img/step4b-mobile-en@2x.6543f45a.webp";